import React from "react";
import { BookOpen, GraduationCap, FileText, ArrowUpRight, ExternalLink } from "lucide-react";

const NAFFY_URL = "https://naffy.io";

const products = [
  {
    icon: GraduationCap,
    tag: "Kurs",
    title: "Spedytor od podstaw",
    desc: "Kompletny kurs dla osób, które chcą wejść w branżę spedycyjną od zera — od rozmowy z klientem po rozliczenie zlecenia.",
    badge: "Popularny",
  },
  {
    icon: BookOpen,
    tag: "E-book",
    title: "Jak zacząć w transporcie i spedycji",
    desc: "Praktyczny przewodnik: od wyboru formy działalności, przez pierwszych klientów, aż po skalowanie floty.",
    badge: "Nowość",
  },
  {
    icon: FileText,
    tag: "Poradnik",
    title: "Prowadzenie firmy transportowej",
    desc: "Zbiór sprawdzonych praktyk, list kontrolnych i procedur dla właścicieli firm transportowych.",
    badge: null,
  },
  {
    icon: FileText,
    tag: "Materiały",
    title: "Pakiet dla właścicieli firm",
    desc: "Gotowe arkusze, checklisty i szablony do natychmiastowego wdrożenia w Twojej firmie.",
    badge: "Wkrótce",
  },
];

export default function Ebooks() {
  return (
    <section
      id="ebooki"
      data-testid="ebooks-section"
      className="section relative overflow-hidden"
    >
      <div className="absolute inset-0 -z-10 bg-[#0c0c0e]" />
      <div className="absolute inset-0 -z-10 opacity-[0.04] pointer-events-none">
        <div className="absolute top-0 left-0 right-0 h-px hairline" />
      </div>

      <div className="container-x">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-10 mb-12">
          <div className="max-w-2xl">
            <span className="eyebrow">Produkty cyfrowe</span>
            <p className="mt-6 text-[16px] md:text-[17px] leading-relaxed text-[#b8b3a7]">
              Tworzę materiały dla osób, które chcą rozwijać się w branży
              transportowej. Wszystko oparte na praktyce — nie na teorii.
              Moje e-booki, kursy i poradniki znajdziesz na platformie{" "}
              <span className="gold-text font-medium">naffy.io</span>.
            </p>
          </div>
          <a
            data-testid="ebooks-naffy-main"
            href={NAFFY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold whitespace-nowrap"
          >
            Zobacz na naffy.io
            <ExternalLink size={16} />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {products.map((p, idx) => {
            const Icon = p.icon;
            return (
              <a
                key={p.title}
                data-testid={`ebook-card-${idx}`}
                href={NAFFY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="card-dark p-8 lg:p-10 block group cursor-pointer"
              >
                <div className="flex items-start justify-between gap-6">
                  <div className="h-14 w-14 border border-[rgba(212,169,74,0.35)] flex items-center justify-center">
                    <Icon className="text-[var(--gold)]" size={24} strokeWidth={1.3} />
                  </div>
                  <div className="flex items-center gap-3">
                    {p.badge && (
                      <span className="text-[10px] tracking-[0.26em] uppercase text-[#121008] bg-[var(--gold)] px-3 py-1 font-semibold">
                        {p.badge}
                      </span>
                    )}
                    <ArrowUpRight
                      size={22}
                      className="text-[var(--gold)] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                    />
                  </div>
                </div>
                <div className="mt-8">
                  <span className="eyebrow">{p.tag}</span>
                  <h3 className="h-display text-[24px] md:text-[28px] mt-4 text-[#f5f1e8]">
                    {p.title}
                  </h3>
                  <p className="mt-4 text-[15px] leading-relaxed text-[#b8b3a7]">
                    {p.desc}
                  </p>
                </div>
              </a>
            );
          })}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-6 text-center">
          <p className="text-[14px] text-[#b8b3a7]">
            Pełna oferta, zakup i dostęp do materiałów:
          </p>
          <a
            data-testid="ebooks-naffy-footer"
            href={NAFFY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost"
          >
            naffy.io/przemyslaw-chudy
            <ExternalLink size={14} />
          </a>
        </div>
      </div>
    </section>
  );
}
